export const contactFileGetters = {
  contactFiles: (state) => state.contactFiles,
  contactFilesSearchResult: (state) => state.contactFilesSearchResult,
  contactFilesStart: (state) => state.contactFilesStart
}